/**
 * SQL 품질 검사 API (docs/features/27-sql-quality.md) — 기준 → 대상 → 기계 검사 → 결과·검토 → 현황·리포트 → 이력.
 * 기계 쪽은 `/sql-quality`(AI 무관), AI 판정만 `/assistant/sql-quality`(문장 하나씩 — 화면이 고른 것만).
 */
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || '/sql-developer';
const ROOT = `${BASE_URL}/sql-quality`;
const AI_ROOT = `${BASE_URL}/assistant/sql-quality`;
const enc = encodeURIComponent;
const LONG = { timeout: 10 * 60 * 1000 };

export async function getChecks() { return (await axios.get(`${ROOT}/checks`)).data; }
export async function getStandardRules() { return (await axios.get(`${ROOT}/standard-rules`)).data; }
export async function listCriteria() { return (await axios.get(`${ROOT}/criteria`)).data; }
export async function getCriteria(id) { return (await axios.get(`${ROOT}/criteria/${enc(id)}`)).data; }
export async function saveCriteria({ id, name, body }) {
  return (id ? await axios.put(`${ROOT}/criteria/${enc(id)}`, { name, body }) : await axios.post(`${ROOT}/criteria`, { name, body })).data;
}
export async function deleteCriteria(id) { return (await axios.delete(`${ROOT}/criteria/${enc(id)}`)).data; }

export async function listJobs(q = '') { return (await axios.get(`${ROOT}/jobs`, { params: { q } })).data; }
export async function createJob({ title, connectionId, criteriaId }) { return (await axios.post(`${ROOT}/jobs`, { title, connectionId, criteriaId })).data; }
export async function getJob(id) { return (await axios.get(`${ROOT}/jobs/${enc(id)}`)).data; }
export async function renameJob(id, title) { return (await axios.put(`${ROOT}/jobs/${enc(id)}`, { title })).data; }
export async function deleteJob(id) { return (await axios.delete(`${ROOT}/jobs/${enc(id)}`)).data; }
export async function cancelJob(id) { return (await axios.post(`${ROOT}/jobs/${enc(id)}/cancel`, {})).data; }
/** 기준을 지금 판으로 다시 가져온다 — criteriaId 를 주면 그 기준으로 바꾼다 */
export async function refreshCriteria(id, criteriaId) { return (await axios.post(`${ROOT}/jobs/${enc(id)}/criteria-refresh`, { criteriaId: criteriaId || undefined })).data; }
/** 대상 — spec { source: 'pool'|'awr'|'csv', kinds, schema, module, q, limit, minExec, days, csvText, replace } */
export async function loadTarget(id, spec) { return (await axios.post(`${ROOT}/jobs/${enc(id)}/target`, { spec }, LONG)).data; }
export async function runCheck(id) { return (await axios.post(`${ROOT}/jobs/${enc(id)}/check`, {}, LONG)).data; }
export async function listItems(id, filter) { return (await axios.post(`${ROOT}/jobs/${enc(id)}/items`, { filter })).data; }
export async function getItem(id, itemId) { return (await axios.get(`${ROOT}/jobs/${enc(id)}/items/${enc(itemId)}`)).data; }
export async function similarItems(id, itemId) { return (await axios.get(`${ROOT}/jobs/${enc(id)}/items/${enc(itemId)}/similar`)).data; }
export async function setReview(id, itemId, { status, note }) { return (await axios.put(`${ROOT}/jobs/${enc(id)}/items/${enc(itemId)}/review`, { status, note })).data; }
/** 검증 쿼리 실행 — 사람이 누를 때만. 연결은 작업의 것(없으면 connectionId) */
export async function runVerify(id, itemId, { index, sql, connectionId }) {
  return (await axios.post(`${ROOT}/jobs/${enc(id)}/items/${enc(itemId)}/verify`, { index, sql, connectionId }, { timeout: 2 * 60 * 1000 })).data;
}
/** 샘플 검사를 (다시) 만든다 — 샘플 쿼리를 검증용 기준으로 돌려 기대 결과와 대조한 작업 */
export async function createSampleJob() { return (await axios.post(`${ROOT}/sample-job`, {})).data; }
export async function getReport(id) { return (await axios.get(`${ROOT}/jobs/${enc(id)}/report`)).data; }
/** 개발자 전달용 CSV — 모든 검사 문장 한 파일, 원문 각 줄에 위반 주석 */
export async function getDeveloperCsv(id) { return (await axios.get(`${ROOT}/jobs/${enc(id)}/developer-csv`)).data; }
/** AI 판정 — 문장 하나 */
export async function aiAnalyze(id, itemId, { provider } = {}, signal) {
  return (await axios.post(`${AI_ROOT}/jobs/${enc(id)}/items/${enc(itemId)}/ai`, { provider }, { timeout: 5 * 60 * 1000, signal })).data;
}
